import { LanguageIcon } from "@components/Icons/Language";
import { getLocaleFlag, useLocales } from "@helpers/locales";
import { useLocalePreference } from "@helpers/useLocalePreference";
import { useTranslation } from "react-i18next";
import { useBranding } from "src/helpers/useBranding";

export const Contact = () => {
  const { emailDomain, instaHandle } = useBranding();
  const { t, i18n } = useTranslation("contact");
  const { setLocale } = useLocalePreference();
  const locales = useLocales(true);

  return (
    <div
      style={{ backgroundImage: `url(/bg-wedding.webp)` }}
      className={`min-h-screen justify-center overflow-hidden bg-slate-800 bg-cover bg-center bg-blend-overlay`}
    >
      <div className="flex justify-center px-4">
        <div className="flex flex-col">
          <div className="mt-16 mr-1 flex justify-end">
            <div className="flex items-center">
              <div className="dropdown-end dropdown">
                <label tabIndex={0} className="btn-primary btn-ghost btn-circle btn">
                  <LanguageIcon className="hidden" />
                  <div className="text-lg">{getLocaleFlag(i18n.language as AppLocale)}</div>
                </label>
                <ul
                  tabIndex={0}
                  className="dropdown-content menu rounded-box menu-compact mt-3 border border-base-300 bg-base-200 p-2 shadow"
                >
                  {locales.length > 1 && (
                    <li className="flex justify-center align-bottom">
                      {locales.map((locale) => (
                        <button
                          key={locale}
                          className={`my-1 flex items-center rounded-lg border-2 border-base-300 bg-base-200 ${locale === i18n.language ? "border-primary font-semibold underline" : ""
                            }}`}
                          onClick={() => {
                            setLocale(locale);
                            (document?.activeElement as any)?.blur();
                          }}
                        >
                          <span className="text-xs uppercase text-neutral">{locale}</span>
                          <span className="text-lg">{getLocaleFlag(locale)}</span>
                        </button>
                      ))}
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="mb-4 flex max-w-sm flex-col justify-between rounded-lg bg-slate-100 p-6">
            <div className="px-4 pt-6 pb-4 text-center">
              <h3 className="text-xl font-bold text-slate-800">{t("getInTouch")}</h3>
              <p className="mt-3 text-slate-600">{t("sendUsAnEmail")}</p>
            </div>

            <div className="flex flex-col items-center justify-center px-4 py-6 text-gray-600">
              <div className="mb-3 font-semibold">{t("emailUs")}</div>
              <div className="text-lg text-primary">
                <span className="blockspam" aria-hidden="true">
                  __
                </span>{" "}
                hello@
                <span className="blockspam" aria-hidden="true">
                  ----
                </span>
                {emailDomain}
              </div>

              <div className="my-6 w-full border-t border-slate-200" />

              <div className="mb-3 font-semibold">{t("orMessageOnInsta")}</div>
              <a
                href={`https://www.instagram.com/${instaHandle.replace("@", "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-primary hover:underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
                {instaHandle}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
